<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 40 40"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M29.1162 15.7829C29.6043 15.2947 30.3957 15.2946 30.884 15.7827L33.334 18.2322L35.7828 15.7829C36.271 15.2947 37.0623 15.2946 37.5507 15.7827C38.0388 16.2708 38.0388 17.0622 37.5508 17.5505L35.1018 20L37.5508 22.4495C38.0388 22.9379 38.0388 23.7292 37.5507 24.2174C37.0623 24.7055 36.271 24.7054 35.7828 24.2172L33.334 21.7679L30.884 24.2174C30.3957 24.7055 29.6043 24.7054 29.1162 24.2172C28.628 23.7289 28.6282 22.9375 29.1163 22.4494L31.5663 20L29.1163 17.5507C28.6282 17.0625 28.628 16.2711 29.1162 15.7829Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M21.728 5.66071C23.6672 4.38209 26.2502 5.77293 26.2502 8.09573V31.9052C26.2502 34.228 23.6672 35.6189 21.728 34.3402L11.7295 27.7479C11.6614 27.703 11.5817 27.679 11.5002 27.679H6.66683C4.13553 27.679 2.0835 25.627 2.0835 23.0957V16.9052C2.0835 14.3739 4.13553 12.3219 6.66683 12.3219H11.5002C11.5817 12.3219 11.6614 12.298 11.7295 12.2531L21.728 5.66071Z"
			fill="black"
		/>
	</svg>
</template>
